import { ChatbotManager, useChatbot } from "@/domains/-chatbot";
import {getUserDefaultLang, i18n, setLocales} from "@/i18n";
import {isExactActiveRoute, router} from "@/router";
import {Lang, sdk} from "@/sdk";
import {AxiosError} from "axios";
import {reactive} from "vue";
import {Router} from "vue-router";
import { useToast } from "vue-toastification";

export class SessionStore {
  public loaded: boolean;
  public authzPin?: string;
  public acceptedLegal: boolean;
  public chatbotManager?: ChatbotManager;
  private promise: undefined | Promise<void>

  constructor() {
    this.loaded = false;
    this.promise = undefined;
    this.acceptedLegal = false;
    this.chatbotManager = useChatbot()
  }

  get isAuthenticated(): boolean {
    return this.authzPin !== undefined
  }

  async loadSession(){
    this.authzPin = localStorage.getItem('omind_authz_pin') || undefined
    this.acceptedLegal = localStorage.getItem('omind_accepted_legal') === '1' ? true : false
    if(this.authzPin){
      try{
        sdk.setPinHeader(this.authzPin)
        await this.chatbotManager?.getHistory()
        //const response = await sdk.getMessages()
      }
      catch(error){
        
        if(error.status && error.status === 429){
            useSessionStore().signOut()
            const toast = useToast()
            toast.error(i18n.global.t('errors.too_many_requests'))
        }
        else{
          throw error
        }
      }
    }
  }

  async setAuthzPin(pin: string){
    
    try{
        sdk.setPinHeader(pin)
        await this.chatbotManager?.getHistory()

        localStorage.setItem('omind_authz_pin', pin)
        this.authzPin = pin    
    }
    catch(error){
        
      if(error.status && error.status === 429){
          useSessionStore().signOut()
          const toast = useToast()
          toast.error(i18n.global.t('errors.too_many_requests'))
      }
      else{
        throw error
      }
    }
  }

  get hasAcceptedLegal() {
    return this.acceptedLegal
  }

  setAcceptedLegal() {
    localStorage.setItem('omind_accepted_legal', '1')
  }

  async signOut() {
    this.unload();
    router.replace({name: 'auth'})
  }

  unload() {
    this.authzPin = undefined
    localStorage.removeItem('omind_authz_pin')
  }

  get lang(): Lang {
    return navigator.language.split('-')[0] as Lang || 'en'
  }
}


let sessionStore: SessionStore;

export function useSessionStore(): SessionStore {
  if (!sessionStore)
    sessionStore = reactive(new SessionStore()) as SessionStore;

  return sessionStore;
}